import React from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import "./Transaction_History_card.css";

function Transaction_History_card({ detail, time, balance, platform_fee, remark, type, status }) {


  const getStatusClass = (status) => {
    switch (status) {
      case "Accepted":
        return "moved_in_amount";   // green
      case "Processing":
        return "text-warning";      // yellow
      case "Rejected":
      case "Failed":
        return "moved_out_amount";  // red
      default:
        return "";
    }
  };
  return (
    <div className="transaction_history_card transaction_history_card-new ">
      <Card className="history_card">
        {/* Header */}
        <Card.Header className="history_card_header">
          {"Transaction History"}
        </Card.Header>

        {/* Body */}
        <Card.Body className="history_card_body">

          {/* <Row className="history_row header_row me-0 ms-0">
            <Col>Status</Col>
            <Col className={`text-end ${getStatusClass(status)}`}>{status}</Col>
          </Row> */}


          <Row className="history_row me-0 ms-0">
            <Col>Time</Col>
            <Col className="text-end">{time}</Col>
          </Row>

          <Row className="history_row me-0 ms-0">
            <Col>Balance</Col>
            <Col
              className={`text-end ${type === "Credit" && status === "Accepted"
                ? "moved_in_amount"
                : "moved_out_amount"
                }`}
            >
              {balance}
            </Col>
          </Row>
          <Row className="history_row header_row me-0 ms-0">
            <Col>Fee</Col>
            <Col className="text-end">{platform_fee}</Col>
          </Row>
          <Row className="history_row header_row me-0 ms-0">
            <Col>Detail</Col>
            <Col className="text-end">{detail}</Col>
          </Row>

          {/* <Row className="history_row me-0 ms-0">
            <Col>Remark</Col>
            <Col className="text-end">{remark}</Col>
          </Row> */}

          {/* <div className="history_empty_box">
            <Form.Group>
              <Form.Control as="textarea" rows={2} />
            </Form.Group>
          </div> */}

        </Card.Body>
      </Card>
    </div>
  );
}

export default Transaction_History_card;